const templateMap = {
    Auckland: () => import('../components/Resume/Templates/Auckland/Auckland'),
    BubbleFish: () => import('../components/Resume/Templates/BubbleFish/BubbleFish'),
    EuroPass: () => import('../components/Resume/Templates/Europass/EuroPass'),
    RadiantMoon: () => import('../components/Resume/Templates/RadiantMoon/RadiantMoon'),
    Standard: () => import('../components/Resume/Templates/Standard/StandardPDF'),
    SwimmingElephant: () => import('../components/Resume/Templates/SwimmingElephant/SwimmingElephant'),
    WaterTrain: () => import('../components/Resume/Templates/WaterTrain/WaterTrain'),
};

const normalizeTemplateName = (name) => {
    if (!name || typeof name !== 'string') return 'Standard';
    return name.replace(/\s+/g, '');
};

/**
 * Lazy-loads the resume template React component used inside PDFViewer.
 * Falls back to the Standard template when a matching template is not found.
 * @param {string} templateName
 * @returns {Promise<React.ComponentType>}
 */
export async function loadResumeTemplateComponent(templateName) {
    const normalized = normalizeTemplateName(templateName);
    const templateLoader = templateMap[normalized] || templateMap.Standard;

    if (!templateLoader) {
        throw new Error('No resume template loader available');
    }

    const module = await templateLoader();
    if (!module?.default) {
        throw new Error('Template component missing default export');
    }
    return module.default;
}

export default loadResumeTemplateComponent;
